import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useParams } from "react-router-dom";
import { ThemeProvider } from "./components/contexts/ThemeContext";
import { NavbarProvider } from "./components/contexts/NavbarContext";
import ReactGA from "react-ga4";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from "./components/ScrollToTop";

import Navbar from "./components/headers/Navbar";
import Footer from "./components/headers/Footer";
import Home from "./components/Home";
import Offers from "./components/Offers";
import Realisations from "./components/Realisations";
import Contact from "./components/Contact";
import About from "./components/About";
import Blog from "./components/Blog";
import ArticleGenericPage from "./components/ArticleGenericPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Terms from "./components/Terms";
import Page404 from "./components/Page404";
import Rdv from "./components/Rdv";
import Cv from "./components/CV";

import ProjectDetail from "./components/pages/ProjectDetail";

import WorkInProgress from "./components/WorkInProgress";
import {
  ABOUT,
  BLOG,
  BLOG_ARTICLE_PATTERN,
  CONTACT,
  HELP,
  HOME,
  OFFER_GROWTH,
  OFFER_MOBILE,
  OFFER_SAAS,
  OFFER_SITES_WEB,
  PRIVACY,
  PROFILE,
  RDV,
  REALISATIONS,
  REALISATION_DETAIL_PATTERN,
  SERVICES,
  TERMS,
  realisationDetail,
} from "./config/routes";

//DuoDate
import DuoPrivacyPolicy from "./components/DuoPrivacyPolicy";
import DuoTerms from "./components/DuoTerms";

function LegacyAchievementRedirect() {
  const { slug } = useParams();
  return <Navigate to={realisationDetail(slug)} replace />;
}

function App() {
  React.useEffect(() => {
    ReactGA.initialize([
    {
        trackingId: "G-7K3TNHP0CP"
      },  
    ]);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <NavbarProvider>
          <Router>
            <ScrollToTop />
            <Navbar />
            <Routes>
              {/* Static Pages */}
              <Route path={HOME} element={<Home />} />
              <Route path={SERVICES} element={<Offers />} />
              <Route path={ABOUT} element={<About />} />
              <Route path={REALISATIONS} element={<Realisations />} />
              <Route path={PROFILE} element={<Cv />} />
              <Route path={BLOG} element={<Blog />} />
              <Route path={HELP} element={<WorkInProgress />} />
              <Route path={CONTACT} element={<Contact />} />
              <Route path={PRIVACY} element={<PrivacyPolicy />} />
              <Route path={TERMS} element={<Terms />} />
              <Route path={RDV} element={<Rdv />} />
              <Route path="/rendez-vous" element={<Navigate to={RDV} replace />} />

              {/* Legacy redirects */}
              <Route path="/offers" element={<Navigate to={SERVICES} replace />} />
              <Route path={OFFER_SITES_WEB} element={<Navigate to={SERVICES} replace />} />
              <Route path={OFFER_SAAS} element={<Navigate to={SERVICES} replace />} />
              <Route path={OFFER_MOBILE} element={<Navigate to={SERVICES} replace />} />
              <Route path={OFFER_GROWTH} element={<Navigate to={SERVICES} replace />} />
              <Route path="/achievements" element={<Navigate to={REALISATIONS} replace />} />
              <Route path="/achievements/:slug" element={<LegacyAchievementRedirect />} />
              <Route path="/about" element={<Navigate to={ABOUT} replace />} />
              <Route path="/cv" element={<Navigate to={PROFILE} replace />} />

              {/* Dynamic Pages */}
              <Route path={REALISATION_DETAIL_PATTERN} element={<ProjectDetail />} />

              <Route path={BLOG_ARTICLE_PATTERN} element={<ArticleGenericPage />} />

              {/* Duo Date Pages */}
              <Route path="/duo-date/privacy-policy" element={<DuoPrivacyPolicy />} />
              <Route path="/duo-date/terms" element={<DuoTerms />} />

              {/* Admin 
              <Route path="/createArticle" element={<CreateArticle />} />*/}
              {/* 404 and 500 pages*/}              
              {/*<Route path="/500" element={<NotFound />} />*/}
              <Route path="*" element={<Page404 />} />
            </Routes>
            <Footer />
          </Router>
        </NavbarProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
